import { Reporter } from '../Reporter.js';
import CventAnalyticsDestination from '../../destinations/CventAnalytics.js';
import AttendeeActivitiesDestination from '../../destinations/AttendeeActivities.js';
import CventAnalyticsWorkerClient from './client/CventAnalyticsWorkerClient.js';
import CventAnalyticsClient from './client/CventAnalyticsClient.js';
import LOG from '../../logger.js';
import Flags from '../../Flags.js';
const cventAnalyticsDestinations = ['CventAnalytics', 'AttendeeActivities'];
class CventAnalyticsReporter extends Reporter {
    constructor(config) {
        super(config);
        this.name = 'CventAnalytics';
        this.defaultDestinations = config.defaultDestinations
            ? Object.fromEntries(config.defaultDestinations.filter(dest => cventAnalyticsDestinations.includes(dest)).map(dest => [dest, true]))
            : {};
        const cventAnalyticsDestination = new CventAnalyticsDestination();
        const attendeeActivitiesDestination = new AttendeeActivitiesDestination();
        this.destinations = new Map([
            [cventAnalyticsDestination.name, cventAnalyticsDestination],
            [attendeeActivitiesDestination.name, attendeeActivitiesDestination]
        ]);
        if (typeof window !== 'undefined' &&
            window.Worker &&
            // Opt-out of worker implementation when using the bundle to compensate for cross-origin concerns
            Flags.worker &&
            // Skip using worker if the reporter is in disabled state
            !this.disabled) {
            // client-side we can use a Worker to offload processing from the main thread
            this.client = new CventAnalyticsWorkerClient({ ...config, onError: this.onError, keepalive: true });
        }
        else {
            this.client = new CventAnalyticsClient({ ...config, onError: this.onError });
        }
    }
    async send(action, data, providedCallback) {
        const callback = providedCallback ||
            (() => {
                LOG.debug(`${action.id} tracked`);
            });
        const destinations = action.destinations && action.destinations.length > 0
            ? action.destinations
                .filter(destination => this.destinations.has(destination.name))
                .map(destination => this.destinations.get(destination.name))
            : Object.entries(this.defaultDestinations)
                .filter(([, enabled]) => enabled)
                .map(([destName]) => this.destinations.get(destName));
        await Promise.all(destinations.map(destination => destination.transform(action, data).then(payload => this.client.send(payload, callback))));
    }
    identify(_user) {
        LOG.debug(`${this.name} reporter does not identify users`);
    }
    alias(_id) {
        LOG.debug(`${this.name} reporter does not support creating an alias for users`);
    }
}
export default CventAnalyticsReporter;
//# sourceMappingURL=CventAnalyticsReporter.js.map